import { toValue } from "vue";
import { useSurveyLocalesStore } from "@stores/survey/surveyLocales";
import { useDecodeMessage } from "@/utils/composables/decodeMessage";
import { CARD_ICONS } from "@utils/constants/cardCatalog";
import { hasEffectiveConditions } from "@utils/conditionData";

export const useQuestionCardTypes = (cardSubTypesInfos) => {
  const determineIcon = (type) => CARD_ICONS[type] ?? CARD_ICONS.unknown;
  const findSubTypeDescriptor = (subType) => toValue(cardSubTypesInfos)?.[subType];
  const determineSubTypeLabel = (subType) => findSubTypeDescriptor(subType)?.name ?? "Unknown";

  return {
    cardSubTypesInfos,
    determineIcon,
    findSubTypeDescriptor,
    determineSubTypeLabel,
  };
};

export const useCardAttributes = () => {
  const surveyLocalesStore = useSurveyLocalesStore();
  const { localizeText, localizeTextWithAnalysisFallback } = surveyLocalesStore;
  const { decodeName } = useDecodeMessage();
  const name = (card) => card.name;
  const token = (card) => card.token;
  const type = (card) => card.type;
  const groupType = (card) => card.groupType;
  const isHidden = (card) => card?.specs?.hidden;
  const hasConditions = (card) => hasEffectiveConditions(card?.specs?.conditions);
  const cardsTitle = (card) => {
    const specs = card?.specs ?? {};
    return decodeName(localizeTextWithAnalysisFallback(specs.question || specs.text || specs.description || specs.prompt)) || "";
  };
  const hasHint = (card) => card?.specs?.has_hint || false;
  const isRandomized = (card) => card?.specs?.random_group || false;
  const hint = (card) => localizeText(card?.specs?.hint) || "  ";
  const url = (card) => localizeText(card?.specs?.url) || "  ";

  return {
    name,
    token,
    type,
    groupType,
    isHidden,
    hasConditions,
    cardsTitle,
    hint,
    hasHint,
    isRandomized,
    url,
  };
};
